module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.76eb1969.webp";